module.exports = __webpack_public_path__ + "static/media/10945695_10205644467131497_3519527541333700608_o.09baccb7.jpg";